"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestManualReading = void 0;
var utils_1 = require("../../../utils");
function getLatestManualReading(readings, mpxn) {
    return readings
        .sort(utils_1.mostRecentFirst)
        .find(function (r) {
        return (0, utils_1.getReadingTypeLabel)(r.readingType) === 'Manual' &&
            (!mpxn || r.mpxn === mpxn);
    });
}
exports.getLatestManualReading = getLatestManualReading;
